import { render, staticRenderFns } from "./AssignmentStatusLabel.vue?vue&type=template&id=bf7eb49a&scoped=true"
import script from "./AssignmentStatusLabel.vue?vue&type=script&lang=js"
export * from "./AssignmentStatusLabel.vue?vue&type=script&lang=js"
import style0 from "./AssignmentStatusLabel.vue?vue&type=style&index=0&id=bf7eb49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7eb49a",
  null
  
)

export default component.exports